import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=fe02024c&scoped=true"
import script from "./Subtitle.vue?vue&type=script&lang=js"
export * from "./Subtitle.vue?vue&type=script&lang=js"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=fe02024c&prod&lang=css"
import style1 from "./Subtitle.vue?vue&type=style&index=1&id=fe02024c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe02024c",
  null
  
)

export default component.exports